<template>
  <div aria-atomic="true" aria-live="polite" class="llp-toast">
    <div class="toast-container position-fixed top-0 end-0">
      <div v-for="(message, index) in messages" :key="index">
        <div ref="toast" :class="classNames" aria-atomic="true" aria-live="assertive" class="toast p-3 m-3"
             data-bs-delay="30000" role="alert">
          <div class="d-flex">
            <div class="toast-body">
              <span>{{ message }}</span>
            </div>
            <button aria-label="Close" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                    type="button"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import { Toast } from 'bootstrap';
import _ from 'lodash'; 
export default {
  name: 'BaseToast',
  data() {
    return {
      messages: [],
      classNames: '',
    };
  },
  methods: {
    show(messages, type) {
      if (_.isEmpty(messages)) {
        return;
      }
 
      let classNames = '';
      messages = Array.isArray(messages) ? messages : [messages];
 
      switch (type) {
        case 'error':
          classNames = 'bg-danger text-white';
          break;
        case 'warning':
          classNames = 'bg-warning text-white';
          break;
        case 'info':
          classNames = 'bg-info text-white';
          break;
        default:
          classNames = 'bg-success text-white';
          break;
      }
 
      this.classNames = classNames;
      this.messages = messages;
      this.$nextTick(() => {
        const toastElList = Array.from(this.$el.querySelectorAll('.toast'));
        toastElList.forEach((toastEl) => {
          const toast = Toast.getOrCreateInstance(toastEl);
          toast.show();
 
          // Auto close after at least 5 seconds or 50ms per character with 2s animation duration
          const message = toastEl.textContent || '';
          setTimeout(() => {
            toast.hide();
          }, Math.max(5000, 2000 + message.length * 50));
        });
      });
    },
  },
};
</script>